import { getJson, withOptional } from '@rad/utility/http';
export const getPolicyKinds = getJson(`/api/policies`);
export const getCurrentPolicy = (kind) => withOptional(getJson(`/api/policies/${kind}`));
